import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import Api from 'hooks/Api';
import { toastSuccess } from 'ui/partials/Toast';
import { useProfile } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';

import { REGISTER_FORM } from '../Register';

interface Payload extends REGISTER_FORM {
  referralCode?: string | null;
}

export default function useRegister() {
  const { state } = useProvider();
  const { setProfile } = useProfile();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (payload: Payload) => {
      const api = new Api(state);

      const data = await api.post({
        url: 'api/v3/auth/accounts/register',
        payload,
      });

      return data;
    },
    onSuccess: (successData) => {
      setProfile({ profile: successData.data });
      toastSuccess('Successfully registered');

      navigate('/verify/email');
    },
  });
}
